// core/action/balanceSheetActions.js
import { balanceSheetAPI } from './api';
import { toast } from 'react-toastify';

export const balanceSheetActions = {
    // Get balance sheet data
    getBalanceSheet: async (params = {}) => {
        try {
            const response = await balanceSheetAPI.get(params);
            if (response.data) {
                return {
                    success: true,
                    data: response.data
                };
            } else {
                return {
                    success: false,
                    message: 'Invalid API response format',
                    data: {
                        as_on_date: new Date().toISOString().split('T')[0],
                        summary: {
                            total_assets: 0,
                            total_liabilities: 0,
                            total_equity: 0,
                            net_worth: 0,
                            accounting_equation: true
                        },
                        assets: { categories: [], total: 0 },
                        liabilities: { categories: [], total: 0 },
                        equity: { categories: [], total: 0 }
                    }
                };
            }
        } catch (error) {
            console.error('Error fetching balance sheet:', error);
            return {
                success: false,
                message: error.message || 'Failed to fetch balance sheet',
                data: {
                    as_on_date: new Date().toISOString().split('T')[0],
                    summary: {
                        total_assets: 0,
                        total_liabilities: 0,
                        total_equity: 0,
                        net_worth: 0,
                        accounting_equation: true
                    },
                    assets: { categories: [], total: 0 },
                    liabilities: { categories: [], total: 0 },
                    equity: { categories: [], total: 0 }
                }
            };
        }
    },

    // Export balance sheet as PDF
    exportToPDF: async (params = {}) => {
        try {
            const response = await balanceSheetAPI.exportPDF(params);
            return response;
        } catch (error) {
            console.error('Error exporting balance sheet:', error);
            toast.error('Failed to export balance sheet');
            return null;
        }
    },

    // Export balance sheet as Excel
    exportToExcel: async (params = {}) => {
        try {
            const response = await balanceSheetAPI.exportExcel(params);
            return response;
        } catch (error) {
            console.error('Error exporting balance sheet:', error);
            toast.error('Failed to export balance sheet');
            return null;
        }
    },

    // Format currency helper
    formatCurrency: (amount, currency = 'INR') => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount || 0);
    },

    // Format percentage
    formatPercentage: (value, total) => {
        if (!total || total === 0) return '0.00%';
        return ((value / total) * 100).toFixed(2) + '%';
    }
};

export default balanceSheetActions;
